<template>
  <div>
    <div v-if="!pageLoading">
      <back-nav to="PersonalDetails" />
      <top-card current="PersonalDetails" :cover="coverType.covertypeId" :amount="coverType.riskPremDto.totalPremium">Kindly provide some additional details before you proceed</top-card>
      <v-card flat class="tw-mt-5 md:tw-mt-16">
        <div class="tw-px-4 md:tw-px-8">
          <card-title icon="mdi-account">Personal Details</card-title>
        </div>
        <div class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
          <v-form v-model="isValid">
            <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-2">
              <v-text-field
                  v-model="form.fullName"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Full Name"
                  type="text"
                  :rules="[required('Full Name')]"
              ></v-text-field>
              <v-text-field
                  v-model="form.mobileNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Mobile No."
                  type="text"
                  :rules="[required('Mobile No.'), mobileFormat()]"
              ></v-text-field>
              <v-text-field
                  v-model="form.email"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Email"
                  type="text"
                  :rules="[required('Email'), emailFormat()]"
              ></v-text-field>
              <v-text-field
                  v-model="form.idNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="ID No."
                  type="number"
                  :rules="[required('ID No.'), nationalIdFormat()]"
              ></v-text-field>
              <v-text-field
                  v-model="form.poBoxNo"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="PO Box No."
                  type="number"
                  :rules="[required('PO Box No.')]"
              ></v-text-field>
              <v-autocomplete
                  v-model="form.postalCode"
                  :loading="postCodeLoading"
                  :items="postCodeItems"
                  :search-input.sync="postCodeSearch"
                  class="my-2 tw-px-0 md:tw-px-6"
                  hide-no-data
                  hide-details
                  label="Postal Code"
                  :rules="[required('Postal Code')]"
              ></v-autocomplete>
              <v-text-field
                  v-model="form.kraPinNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="KRA PIN"
                  type="text"
                  :rules="[required('KRA PIN'), kraPinFormat()]"
              ></v-text-field>
              <v-radio-group v-model="form.gender" class="my-2 tw-px-0 md:tw-px-6" :rules="[required('Gender')]"  row>
                <v-radio label="Male" value="MALE" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
                <v-radio label="Female" value="FEMALE" class="tw-mt-0 md:tw-mt-5"></v-radio>
              </v-radio-group>
              <express-upload :uid="authenticatedUser['custom:kra-pin']" :phoneNumber="authenticatedUser.phone_number" :fullName="authenticatedUser.name" :email="authenticatedUser.email" name="KRA PIN" />
              <express-upload :uid="authenticatedUser['custom:kra-pin']" :phoneNumber="authenticatedUser.phone_number" :fullName="authenticatedUser.name" :email="authenticatedUser.email" name="National ID" />
            </div>
            <div class="tw-w-full" :class="{ 'tw-opacity-60 tw-pointer-events-none': referralFromQuery }">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Are you a direct client or referred to us by an Agent?</h3>
              <hr class="tw-mt-3 tw-mb-5">

              <v-radio-group class="my-2 tw-px-0 md:tw-px-6" v-model="form.agent_option" :rules="[v => !!v || 'Selection choice is required']" row :disabled="referralFromQuery">
                <v-radio label="Direct client" :value="1" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
                <v-radio label="Referred by Agent" :value="2" class="tw-mt-0 md:tw-mt-5"></v-radio>
              </v-radio-group>
          </div>
          <div v-if="form.agent_option === 2" :class="{ 'tw-opacity-60 tw-pointer-events-none': referralFromQuery }">
              <v-autocomplete
                id="agentList"
                v-model="agent"
                :loading="agentLoading"
                :items="agentListItems"
                :search-input.sync="agentListSearch"
                class="tw-w-full md:tw-w-1/2 tw-mt-6 md:tw-mt-0 mx-4"
                hide-no-data
                hide-details
                label="Agent"
                :rules="[required('Agent')]"
                :disabled="referralFromQuery"
            ></v-autocomplete>
            </div>

            <div class="tw-w-full">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Preferred policy start date.</h3>
              <hr class="tw-mt-3 tw-mb-5">
            </div>

            <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-mt-4 md:tw-mt-10">
              <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="computedDateFormatted"
                      label="Start Date"
                      persistent-hint
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[required('Start Date')]"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" :min="new Date().toISOString().substr(0, 10)" no-title @input="menu = false" color="primary"></v-date-picker>
              </v-menu>
            </div>

            <div v-if="coverType.covertypeId === 101 && 'additionalBenefits' in this.coverType && beneficiaries.length > 0">
              <div class="tw-w-full">
                <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Add Beneficiary details for travel embedded</h3>
                <hr class="tw-mt-3 tw-mb-5">
              </div>

              <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-mt-4 md:tw-mt-10">
                <v-card v-for="(beneficiary, counter) in beneficiaries" :key="counter" class="tw-w-64 tw-my-4 mx-auto tw-p-3" outlined>
                  <div class="tw-w-full tw-flex tw-justify-end tw-absolute tw--ml-4 tw--mt-2">
                    <v-icon :id="'deleteBeneficiary-' + counter" class="tw-bg-red-700 tw-rounded-full tw-p-1 tw-cursor-pointer" title="remove beneficiary" size="17" color="#fff" @click="deleteBeneficiaries(counter)">mdi-close</v-icon>
                  </div>
                  <div>
                    <h5 class="c-blue-text c-title tw-text-sm">Beneficiary {{ counter+1 }}</h5>
                  </div>
                  <v-text-field v-model="beneficiary.fullName" label="Full Name" class="my-2" :rules="[required('Full Name')]"></v-text-field>
                  <v-text-field v-model="beneficiary.passportNumber" label="Passport No." class="my-2" :rules="[required('Passport No.')]"></v-text-field>
                  <v-select v-model="beneficiary.relationship" :items="relationship" label="Relationship" class="my-2" :rules="[required('Relationship')]"></v-select>
                  <v-menu
                      v-model="beneficiary.menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="beneficiary.dateOfBirth"
                          label="Date of Birth"
                          persistent-hint
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[required('Date Of Birth')]"
                      ></v-text-field>
                    </template>
                    <v-date-picker :ref="'picker_'+counter" v-model="beneficiary.date" no-title @input="beneficiary.menu = false" :max="new Date().toISOString().substr(0, 10)" min="1950-01-01" color="primary"></v-date-picker>
                  </v-menu>
                </v-card>
              </div>
            </div>

            <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
              <v-btn block large
                     color="secondary"
                     class="my-3 "
                     :loading="loading"
                     @click="proceed"
                     :disabled="!isValid"
              >
                {{ isValid ? 'Continue' : 'Check if all fields are filled' }}
              </v-btn>
            </v-card-actions>

          </v-form>
        </div>
      </v-card>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="80"
          color="primary1"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary,no-unused-expressions */

import CardTitle from '@/components/shared/CardTitle';
import TopCard from '@/components/buy/TopCard';
import { formatDate, formatDate2, changeFormat } from '@/utils/time';
import BackNav from '@/components/buy/BackNav';
import { mapGetters } from 'vuex';
import validations from '@/utils/validations';
import axios from 'axios';
import { getReferralAgentCode, validateReferralCode } from '@/services/referralApi';
import postalCodes from '@/utils/postalCodes.json';
import { FB_BUY_PERSONAL } from '@/utils/const';
import ExpressUpload from '@/components/shared/ExpressUpload';

export default {
  name: 'PersonalDetails',
  components: {
    ExpressUpload, BackNav, TopCard, CardTitle,
  },
  data: () => ({
    // date: new Date().toISOString().substr(0, 10),
    date: '',
    menu: false,
    loading: false,
    isValid: false,
    relationship: ['FATHER', 'MOTHER', 'SPOUSE', 'CHILD'],
    beneficiaries: [],
    benefit: '',
    form: {},
    pageLoading: true,
    ...validations,
    postCodeLoading: false,
    postCodeItems: [],
    postCodeSearch: null,
    agentList: [],
    agent: null,
    agentObj: {},
    agentListSearch: null,
    agentListItems: [],
    agentLoading: false,
    agentId: 0,
    referralAgent: null,
    referralFromQuery: false,
  }),
  computed: {
    ...mapGetters('rfq', ['getQoute']),
    ...mapGetters('auth', ['isAuthenticated', 'authenticatedUser']),
    coverType() {
      return this.getQoute !== {} ? this.getQoute.covertypes.find((e) => e.riskId === this.benefit) : {};
    },
    computedDateFormatted() {
      return this.form.coverFrom || this.formatDate(this.date);
    },
  },
  watch: {
    postCodeSearch(val) {
      val && val !== this.form.postalCode && this.postCodeFilter(val);
    },
    // eslint-disable-next-line no-unused-vars
    date(val) {
      this.form.coverFrom = this.formatDate(this.date);
    },
    async agentListSearch(val) {
      if (this.referralFromQuery) return;
      // eslint-disable-next-line no-unused-expressions
      val && val !== this.agentList && this.agentListFilter(val);

      this.agentObj = await this.agentList.find((x) => x.agencyName === this.agent);
      this.agentId = this.agentObj ? this.agentObj.agencyCode : 0;
    },
    beneficiaries: {
      deep: true,
      handler(val) {
        val.forEach((v, i) => {
          if (v.menu === true) {
            // eslint-disable-next-line no-unused-expressions,no-return-assign
            v && setTimeout(() => (this.$refs[`picker_${i}`][0].activePicker = 'YEAR'));
          }
        });

        val.map((v) => {
          if (v.date !== '') {
            // eslint-disable-next-line no-param-reassign
            v.dateOfBirth = this.formatDate(v.date);
          }
          return v;
        });
      },
    },
  },
  mounted() {
    const quote = this.$route.query.q;
    const benefit = this.$route.query.b;
    const pin = this.authenticatedUser['custom:kra-pin'];
    const agentCode = getReferralAgentCode(this.$route.query);
    this.getagentList();
    if (agentCode) {
      validateReferralCode(agentCode).then((result) => {
        if (result) {
          this.referralAgent = result;
          this.referralFromQuery = true;
          this.applyReferralAgent();
        }
      });
    }
    if (!!quote && !!benefit) {
      this.benefit = parseInt(benefit, 10);
      this.$store.dispatch('rfq/getQuotation', quote).then(() => {
        this.bankNameItems = ['bankName' in this.getQoute.client ? this.getQoute.client.bankName : ''];
        this.bankBranchItems = ['bankBranch' in this.getQoute.client ? this.getQoute.client.bankBranch : ''];
        this.form = {
          addressLine1: '1245',
          bankAccount: 'bankAccount' in this.getQoute.client ? this.getQoute.client.bankAccount : '',
          bankBranch: 'bankBranch' in this.getQoute.client ? this.getQoute.client.bankBranch : '',
          bankName: 'bankName' in this.getQoute.client ? this.getQoute.client.bankName : '',
          carDTOS: [this.coverType.car],
          coverFrom: 'coverFrom' in this.getQoute ? this.changeFormat(this.getQoute.coverFrom) : '',
          documents: [],
          email: this.getQoute.client.email || this.isAuthenticated ? this.authenticatedUser.email : '',
          fullName: this.getQoute.client.fullName || this.isAuthenticated ? this.authenticatedUser.name : '',
          idNumber: 'idNumber' in this.getQoute.client ? this.getQoute.client.idNumber : this.isAuthenticated ? this.authenticatedUser['custom:id_number'] : '',
          kraPinNumber: this.getQoute.client.kraPinNumber || this.isAuthenticated ? pin : '',
          mobileNumber: 'mobileNumber' in this.getQoute.client ? this.getQoute.client.mobileNumber : this.isAuthenticated ? this.authenticatedUser.phone_number : '',
          pinNumber: this.isAuthenticated ? pin : '',
          poBoxNo: 'poBoxNo' in this.getQoute.client ? this.getQoute.client.poBoxNo : '',
          postalCode: 'postalCode' in this.getQoute.client ? this.getQoute.client.postalCode : '',
          prodId: this.coverType.productCode,
          quoteId: parseInt(quote, 10),
          selectedRiskId: parseInt(benefit, 10),
          stepCode: 'PROVIDE_DETAILS',
          gender: 'gender' in this.getQoute.client ? this.getQoute.client.gender : '',
        };
        this.postCodeItems = ['postalCode' in this.getQoute.client ? this.getQoute.client.postalCode : ''];
        this.pageLoading = false;
        this.applyReferralAgent();
        if (this.coverType.covertypeId === 101 && 'additionalBenefits' in this.coverType) {
          if ('beneficiaries' in this.coverType) {
            this.coverType.beneficiaries.forEach((b) => {
              this.beneficiaries.push({
                fullName: b.fullName, passportNumber: b.passportNumber, dateOfBirth: b.dateOfBirth, relationship: b.relationship, menu: false, date: '',
              });
            });
          } else {
            const travelEmbed = this.coverType.additionalBenefits.find((e) => e.id === 234);
            if (travelEmbed !== undefined) {
              // eslint-disable-next-line no-plusplus
              for (let i = 0; i < parseInt(travelEmbed.noOfBeneficiaries, 10); i++) {
                this.beneficiaries.push({
                  fullName: '',
                  passportNumber: '',
                  dateOfBirth: '',
                  relationship: '',
                  menu: false,
                  date: '',
                });
              }
            }
          }
        }
        this.$root.$emit('qoute-loaded');
      });
    }
  },
  methods: {
    applyReferralAgent() {
      if (!this.referralAgent || !this.form || typeof this.form !== 'object') return;
      this.form.agent_option = 2;
      this.agent = this.referralAgent.agencyName;
      this.agentId = this.referralAgent.agencyCode;
      this.agentListItems = [this.referralAgent.agencyName];
      this.agentObj = { agencyCode: this.referralAgent.agencyCode, agencyName: this.referralAgent.agencyName };
    },
    selectAgentID() {
      if (this.form.agent_option === 1) {
        this.agentId = '0';
      }
    },
    async proceed() {
      this.loading = true;
      if (this.beneficiaries.length > 0) {
        const requestBenefits = [];
        this.beneficiaries.forEach((b) => {
          requestBenefits.push({
            fullName: b.fullName, passportNumber: b.passportNumber, dateOfBirth: b.dateOfBirth, relationship: b.relationship.toUpperCase(),
          });
        });
        const benefitData = {
          beneficiaries: requestBenefits,
          selectedRiskId: this.benefit,
        };
        await axios.put('/customer/quotation/beneficiary/change', benefitData)
        // eslint-disable-next-line no-unused-vars
          .then((_response) => {
            this.$toast.success('Beneficiries Successfully added', 'Beneficiaries');
          });
      }
      const y = { agentId: this.agentId };
      window.localStorage.setItem('agentId', this.agentId);
      const updateData = Object.assign(y, this.$data.form);
      await axios.put('/customer/quotation/update', updateData)
      // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.$toast.success('Personal Details confirmed successfully', 'Details');
          this.loading = false;
          this.$analytics.logEvent(FB_BUY_PERSONAL);
          this.$emit('to-car-details');
        });
    },
    getagentList() {
      this.agentLoading = true;
      axios.get('/customer/gis/coresetups/agencies/all').then((response) => {
        this.agentLoading = false;
        this.agentList = response.data.object;
      });
    },
    agentListFilter(v) {
      const agents = [];
      this.agentList.forEach((agent) => {
        agents.push(agent.agencyName);
      });
      setTimeout(() => {
        this.agentListItems = agents.filter((e) => (e || '').toUpperCase().indexOf((v || '').toUpperCase()) > -1);
      }, 500);
    },
    formatDate,
    formatDate2,
    changeFormat,
    deleteBeneficiaries(counter) {
      this.beneficiaries.splice(counter, 1);
    },
    postCodeFilter(v) {
      this.postCodeLoading = true;
      setTimeout(() => {
        this.postCodeItems = postalCodes.filter((e) => (e || '').toUpperCase().indexOf((v || '').toUpperCase()) > -1);
        this.postCodeLoading = false;
      }, 500);
    },
  },

};
</script>
